module.exports = require("./lrc");